<main class="main-home-secton">
  <div class="event-main">
    <div class="container-fluid">
      <div class="div-header">
        <h1>Corporate Profile</h1>
      </div>
      <div class="div-contents">
        <form action="" [formGroup]="corporateProfileForm">
          <p class="sub-title">Corporate Details</p>
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12 col-12" class="mobile-view">
              <div class="text-center p-relative">
                <div class="circle">
                  <img class="profile-pic" [src]="image_urls" />
                </div>
                <div class="p-image">
                  <label for="files"
                    ><i class="fa fa-camera upload-button"></i
                  ></label>
                  <input
                    class="file-upload"
                    (change)="onSelectImage($event)"
                    id="files"
                    type="file"
                    accept="image/*"
                  />
                </div>
                <p class="logo-span">Logo <span class="text-danger">*</span></p>
                <p>
                  <span class="noti-span"
                    >(Supported Format: png,jpg,jpeg) <br />(Max file size:
                    10mb)</span
                  >
                </p>
                <p *ngIf="logoCheck == true" class="text-danger">
                  Logo is required
                </p>
              </div>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-12 col-12">
              <div class="row">
                <div class="col-lg-12 col-md-9 col-sm-12 col-12">
                  <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label
                            >Corporate Name<span class="text-danger"
                              >*</span
                            ></mat-label
                          >
                          <input
                            matInput
                            placeholder="Enter Corporate Name"
                            formControlName="organizationName"
                            [ngClass]="{
                              'is-invalid':
                                add.organizationName.touched &&
                                add.organizationName.errors
                            }"
                          />
                          <mat-error
                            *ngIf="
                              add.organizationName.touched &&
                              add.organizationName.errors
                            "
                          >
                            <span *ngIf="add.organizationName.errors.required"
                              >Corporate Name is required</span
                            >
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label
                            >Email ID
                            <span class="text-danger">*</span></mat-label
                          >
                          <input
                            matInput
                            formControlName="email"
                            placeholder="Enter Email ID"
                            oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
                            type="text"
                            (keydown.space)="$event.preventDefault()"
                            [ngClass]="{
                              'is-invalid':
                                add.email.touched && add.email.errors
                            }"
                          />
                          <mat-error
                            *ngIf="add.email.touched && add.email.errors"
                          >
                            <span *ngIf="add.email.errors.required"
                              >Email ID is required</span
                            >
                            <span *ngIf="add.email.errors.email">
                              <i class="fas fa-exclamation-triangle"></i>
                              Invalid Email
                            </span>
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label
                            >Mobile<span class="text-danger">*</span></mat-label
                          >
                          <input
                            matInput
                            type="text"
                            maxlength="10"
                            minlength="10"
                            oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                            placeholder="Enter Mobile Number"
                            formControlName="phone"
                            [ngClass]="{
                              'is-invalid':
                                add.phone.touched && add.phone.errors
                            }"
                          />
                          <mat-error
                            *ngIf="add.phone.touched && add.phone.errors"
                          >
                            <span *ngIf="add.phone.errors.required"
                              >Mobile Number is required</span
                            >
                            <span *ngIf="add.phone.errors.pattern">
                              <i class="fas fa-exclamation-triangle"></i>
                              Mobile Number is Invalid
                            </span>
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label
                            >Year of Establishment
                            <span class="text-danger">*</span></mat-label
                          >
                          <mat-select
                            formControlName="incubatorYearofEstd"
                            [ngClass]="{
                              'is-invalid':
                                add.incubatorYearofEstd.touched &&
                                add.incubatorYearofEstd.errors
                            }"
                          >
                            <mat-option
                              *ngFor="let list of yearData"
                              [value]="list"
                            >
                              {{ list }}
                            </mat-option>
                          </mat-select>
                          <mat-error
                            *ngIf="
                              add.incubatorYearofEstd.touched &&
                              add.incubatorYearofEstd.errors
                            "
                          >
                            <span
                              *ngIf="add.incubatorYearofEstd.errors.required"
                              >Year of Establishment is required</span
                            >
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label
                            >Address Details
                            <span class="text-danger">*</span></mat-label
                          >
                          <input
                            matInput
                            placeholder="Enter Address Details"
                            formControlName="incubatorRegAddressLine1"
                            [ngClass]="{
                              'is-invalid':
                                add.incubatorRegAddressLine1.touched &&
                                add.incubatorRegAddressLine1.errors
                            }"
                          />
                          <mat-error
                            *ngIf="
                              add.incubatorRegAddressLine1.touched &&
                              add.incubatorRegAddressLine1.errors
                            "
                          >
                            <span
                              *ngIf="
                                add.incubatorRegAddressLine1.errors.required
                              "
                              >Address Details is required</span
                            >
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label
                            >Website<span class="text-danger"
                              >*</span
                            ></mat-label
                          >
                          <input
                            matInput
                            placeholder="Enter Website "
                            formControlName="incubatorWebsite"
                            [ngClass]="{
                              'is-invalid':
                                add.incubatorWebsite.touched &&
                                add.incubatorWebsite.errors
                            }"
                          />
                          <mat-error
                            *ngIf="
                              add.incubatorWebsite.touched &&
                              add.incubatorWebsite.errors
                            "
                          >
                            <span *ngIf="add.incubatorWebsite.errors.required"
                              >Website is required</span
                            >
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label vlue="contry"
                            >Country
                            <span class="text-danger">*</span></mat-label
                          >
                          <mat-select
                            formControlName="incubatorcontryList"
                            (selectionChange)="onSelectCountry($event.value)"
                          >
                            <mat-option value="India">India</mat-option>
                            <mat-option value="Other">Other</mat-option>
                          </mat-select>
                          <mat-error
                            *ngIf="
                              add.incubatorcontryList.touched &&
                              add.incubatorcontryList.errors
                            "
                          >
                            <span
                              *ngIf="add.incubatorcontryList.errors.required"
                              >Country is required</span
                            >
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div
                      class="col-lg-4 col-md-6 col-sm-6 col-12"
                      *ngIf="
                        selectedCountry != 'India' &&
                        selectedCountry != undefined
                      "
                    >
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label
                            >Other's Country
                            <span class="text-danger">*</span></mat-label
                          >
                          <input
                            matInput
                            placeholder="Enter Country"
                            formControlName="incubatorOprCountry"
                          />
                          <mat-error
                            *ngIf="
                              add.incubatorOprCountry.touched &&
                              add.incubatorOprCountry.errors
                            "
                          >
                            <span
                              *ngIf="add.incubatorOprCountry.errors.required"
                              >Country is required</span
                            >
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div
                      class="col-lg-4 col-md-6 col-sm-6 col-12"
                      *ngIf="selectedCountry == 'India'"
                    >
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label
                            >State <span class="text-danger">*</span></mat-label
                          >
                          <input
                            matInput
                            placeholder="Enter State"
                            type="text"
                            appBlockCharsInput
                            formControlName="incubatorOprState"
                            [ngClass]="{
                              'is-invalid':
                                corporateProfileForm.get('incubatorOprState')
                                  .touched &&
                                corporateProfileForm.get('incubatorOprState')
                                  .errors
                            }"
                          />
                          <mat-error
                            *ngIf="
                              corporateProfileForm.get('incubatorOprState')
                                .touched &&
                              corporateProfileForm.get('incubatorOprState')
                                .errors
                            "
                          >
                            <span
                              *ngIf="
                                corporateProfileForm.get('incubatorOprState')
                                  .errors.required
                              "
                              >State is required</span
                            >
                            <span
                              *ngIf="
                                corporateProfileForm
                                  .get('incubatorOprState')
                                  .hasError('restrictedChars')
                              "
                            >
                              <i class="fas fa-exclamation-triangle"></i>
                              State is Invalid
                            </span>
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div
                      class="col-lg-4 col-md-6 col-sm-6 col-12"
                      *ngIf="selectedCountry == 'India'"
                    >
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label
                            >District
                            <span class="text-danger">*</span></mat-label
                          >
                          <input
                            matInput
                            placeholder="Enter District"
                            formControlName="incubatorDistrict"
                            [ngClass]="{
                              'is-invalid':
                                corporateProfileForm.get('incubatorDistrict')
                                  .touched &&
                                corporateProfileForm.get('incubatorDistrict')
                                  .errors
                            }"
                          />
                          <mat-error
                            *ngIf="
                              corporateProfileForm.get('incubatorDistrict')
                                .touched &&
                              corporateProfileForm.get('incubatorDistrict')
                                .errors
                            "
                          >
                            <span
                              *ngIf="
                                corporateProfileForm.get('incubatorDistrict')
                                  .errors.required
                              "
                              >District is required</span
                            >
                            <span
                              *ngIf="
                                corporateProfileForm
                                  .get('incubatorDistrict')
                                  .hasError('restrictedChars')
                              "
                            >
                              <i class="fas fa-exclamation-triangle"></i>
                              District is Invalid
                            </span>
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-8 col-md-6 col-sm-6 col-12">
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          style="width: 100%"
                          appearance="outline"
                        >
                          <mat-label
                            >Short Description<span class="text-danger"
                              >*</span
                            ></mat-label
                          >
                          <textarea
                            matInput
                            placeholder="Enter Short Description"
                            formControlName="incubatorRegDesc"
                            cols="30"
                            rows="3"
                            type="text"
                            #message
                            [ngClass]="{
                              'is-invalid':
                                add.incubatorRegDesc.touched &&
                                add.incubatorRegDesc.errors
                            }"
                          ></textarea>
                          <mat-hint matSuffix>{{
                            message.value.length
                          }}</mat-hint>
                          <mat-error
                            *ngIf="
                              add.incubatorRegDesc.touched &&
                              add.incubatorRegDesc.errors
                            "
                          >
                            <span *ngIf="add.incubatorRegDesc.errors.required"
                              >Short Description is required</span
                            >
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <p class="sub-title">CEO/ MD Details</p>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label
                            >Name of CEO/MD
                            <span class="text-danger">*</span></mat-label
                          >
                          <input
                            matInput
                            placeholder="Enter CEO/MD Name"
                            formControlName="ceoOrMdRegName"
                            [ngClass]="{
                              'is-invalid':
                                add.ceoOrMdRegName.touched &&
                                add.ceoOrMdRegName.errors
                            }"
                          />
                          <mat-error
                            *ngIf="
                              add.ceoOrMdRegName.touched &&
                              add.ceoOrMdRegName.errors
                            "
                          >
                            <span *ngIf="add.ceoOrMdRegName.errors.required"
                              >CEO/MD Name is required</span
                            >
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label
                            >Email ID
                            <span class="text-danger">*</span></mat-label
                          >
                          <input
                            matInput
                            formControlName="ceoOrMdRegEmail"
                            placeholder="Enter Email ID"
                            oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
                            type="text"
                            (keydown.space)="$event.preventDefault()"
                            [ngClass]="{
                              'is-invalid':
                                add.ceoOrMdRegEmail.touched &&
                                add.ceoOrMdRegEmail.errors
                            }"
                          />
                          <mat-error
                            *ngIf="
                              add.ceoOrMdRegEmail.touched &&
                              add.ceoOrMdRegEmail.errors
                            "
                          >
                            <span *ngIf="add.ceoOrMdRegEmail.errors.required"
                              >Email ID is required</span
                            >
                            <span *ngIf="add.ceoOrMdRegEmail.errors.email">
                              <i class="fas fa-exclamation-triangle"></i>
                              Invalid Email
                            </span>
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label>Mobile</mat-label>
                          <input
                            matInput
                            placeholder="Enter Mobile Number"
                            formControlName="ceoOrMdRegPhone"
                            oninput="this.value = this.value.replace(/[^0-9.]/g,'')"
                            maxlength="10"
                            minlength="10"
                            [ngClass]="{
                              'is-invalid':
                                add.ceoOrMdRegPhone.touched &&
                                add.ceoOrMdRegPhone.errors
                            }"
                          />
                          <mat-error
                            *ngIf="
                              add.ceoOrMdRegPhone.touched &&
                              add.ceoOrMdRegPhone.errors
                            "
                          >
                            <span *ngIf="add.ceoOrMdRegPhone.errors.required"
                              >Mobile Number is required</span
                            >
                            <span *ngIf="add.ceoOrMdRegPhone.errors.pattern">
                              <i class="fas fa-exclamation-triangle"></i>
                              Mobile Number is Invalid
                            </span>
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <p class="sub-title">SPOC Details</p>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label
                            >SPOC Name<span class="text-danger"
                              >*</span
                            ></mat-label
                          >
                          <input
                            matInput
                            placeholder="Enter SPOC Name"
                            formControlName="incubatorTeamFirstName"
                            [ngClass]="{
                              'is-invalid':
                                add.incubatorTeamFirstName.touched &&
                                add.incubatorTeamFirstName.errors
                            }"
                          />
                          <mat-error
                            *ngIf="
                              add.incubatorTeamFirstName.touched &&
                              add.incubatorTeamFirstName.errors
                            "
                          >
                            <span
                              *ngIf="add.incubatorTeamFirstName.errors.required"
                              >SPOC Name is required</span
                            >
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label
                            >SPOC Email<span class="text-danger"
                              >*</span
                            ></mat-label
                          >
                          <input
                            matInput
                            placeholder="Enter SPOC ID Email"
                            formControlName="incubatorTeamEmail"
                            oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
                            type="text"
                            (keydown.space)="$event.preventDefault()"
                            [ngClass]="{
                              'is-invalid':
                                add.incubatorTeamEmail.touched &&
                                add.incubatorTeamEmail.errors
                            }"
                          />
                          <mat-error
                            *ngIf="
                              add.incubatorTeamEmail.touched &&
                              add.incubatorTeamEmail.errors
                            "
                          >
                            <span *ngIf="add.incubatorTeamEmail.errors.required"
                              >Email ID is required</span
                            >
                            <span *ngIf="add.incubatorTeamEmail.errors.email">
                              <i class="fas fa-exclamation-triangle"></i>
                              Invalid Email
                            </span>
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label
                            >SPOC Mobile<span class="text-danger"
                              >*</span
                            ></mat-label
                          >
                          <input
                            matInput
                            placeholder="Enter SPOC Mobile Number"
                            formControlName="incubatorTeamPhone"
                            oninput="this.value = this.value.replace(/[^0-9.]/g,'')"
                            maxlength="10"
                            minlength="10"
                            [ngClass]="{
                              'is-invalid':
                                add.incubatorTeamPhone.touched &&
                                add.incubatorTeamPhone.errors
                            }"
                          />
                          <mat-error
                            *ngIf="
                              add.incubatorTeamPhone.touched &&
                              add.incubatorTeamPhone.errors
                            "
                          >
                            <span *ngIf="add.incubatorTeamPhone.errors.required"
                              >SPOC Mobile Number is required</span
                            >
                            <span *ngIf="add.incubatorTeamPhone.errors.pattern">
                              <i class="fas fa-exclamation-triangle"></i>
                              SPOC Mobile Number is Invalid
                            </span>
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="col-lg-12 col-md-6 col-sm-12">
                      <p class="sub-title">Additional Details</p>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label
                            >Sectors
                            <span class="text-danger">*</span></mat-label
                          >
                          <mat-select
                            formControlName="sector"
                            multiple
                            (selectionChange)="change1($event)"
                            [ngClass]="{
                              'is-invalid':
                                add.sector.touched && add.sector.errors
                            }"
                          >
                            <mat-option
                              *ngFor="let sector of allSectors"
                              [value]="sector"
                              >{{ sector }}</mat-option
                            >
                          </mat-select>
                          <mat-error
                            *ngIf="add.sector.touched && add.sector.errors"
                          >
                            <span *ngIf="add.sector.errors.required"
                              >Sector is required</span
                            >
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12">
                      <div class="form-rows">
                        <mat-form-field
                          class="material-full-width"
                          appearance="outline"
                        >
                          <mat-label>Interested Districts</mat-label>
                          <mat-select
                            formControlName="incubatorOprInterestedDistricts"
                            multiple
                            (selectionChange)="change($event)"
                            [ngClass]="{
                              'is-invalid':
                                add.incubatorOprInterestedDistricts.touched &&
                                add.incubatorOprInterestedDistricts.errors
                            }"
                          >
                            <mat-option
                              *ngFor="let districtlist of districtdataList"
                              [value]="districtlist"
                              >{{ districtlist }}</mat-option
                            >
                          </mat-select>
                          <mat-error
                            *ngIf="
                              add.incubatorOprInterestedDistricts.touched &&
                              add.incubatorOprInterestedDistricts.errors
                            "
                          >
                            <span
                              *ngIf="
                                add.incubatorOprInterestedDistricts.errors
                                  .required
                              "
                              >Intrested Districts is required</span
                            >
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="d-flex">
                        <mat-label
                          >Incorporation certificate
                          <span class="text-danger">*</span>
                        </mat-label>
                        <div class="ml-auto">
                          <i
                            class="fas fa-plus-circle adddoc-icon"
                            (click)="newaddDocument()"
                          ></i>
                          Add Document
                        </div>
                      </div>
                      <div class="row" formGroupName="documents">
                        <div
                          class="col-lg-4 col-md-6 col-sm-12"
                          *ngFor="let item of array.controls; let i = index"
                          [formGroup]="item"
                        >
                          <div>
                            <div class="form-rows mt-3">
                              <label
                                *ngIf="item.controls.id.value != 0"
                                for="input-file-id{{ i }}"
                                class="md-button md-raised md-accent"
                              >
                                Update File
                                <ion-icon
                                  class="ml-3"
                                  name="cloud-upload-outline"
                                ></ion-icon>
                                <span class="ml-3">✔ File Uploaded</span>
                                <input
                                  class="d-none"
                                  id="input-file-id{{ i }}"
                                  type="file"
                                  (change)="fileRegUpload($event, i)"
                                  formControlName="documentName"
                                  [ngClass]="{
                                    'is-invalid':
                                      item.controls.documentName.touched &&
                                      item.controls.documentName.errors
                                  }"
                                />
                              </label>
                              <label
                                *ngIf="item.controls.id.value == 0"
                                for="input-file-id{{ i }}"
                                class="md-button md-raised md-primary"
                              >
                                Choose File
                                <ion-icon
                                  class="ml-3"
                                  name="cloud-upload-outline"
                                ></ion-icon>
                                <span
                                  class="ml-3"
                                  *ngIf="
                                    item.controls.documentName.value &&
                                    isFileTypeValid(
                                      item.controls.documentName.value
                                    )
                                  "
                                >
                                  ✔ Uploaded
                                </span>
                                <input
                                  class="d-none"
                                  id="input-file-id{{ i }}"
                                  type="file"
                                  accept=".png, .jpg, .jpeg, .pdf"
                                  (change)="fileRegUpload($event, i)"
                                  formControlName="documentName"
                                  [ngClass]="{
                                    'is-invalid':
                                      item.controls.documentName.touched &&
                                      item.controls.documentName.errors
                                  }"
                                />
                              </label>

                              <span class="noti-span"
                                >(Supported Format: png, jpg, jpeg, pdf)
                                <span
                                  class="delete-span"
                                  (click)="deleteRow(i, item.controls.id.value)"
                                >
                                  <i
                                    class="fas fa-trash delete-i"
                                    aria-hidden="true"
                                  ></i>
                                </span>
                              </span>
                              <span class="noti-span"
                                >(Max file size: 10mb)</span
                              >
                              <div
                                *ngIf="
                                  item.controls.documentName.touched &&
                                  item.controls.documentName.errors
                                "
                              >
                                <span
                                  class="text-danger"
                                  *ngIf="
                                    item.controls.documentName.errors.required
                                  "
                                >
                                  Document is required
                                </span>
                              </div>
                              <div
                                class="text-center mt-2 mb-3"
                                *ngIf="item.controls.id.value != 0"
                              >
                                <a
                                  class="pdf-btn"
                                  href="{{ sam[i] }}"
                                  target="_blank"
                                  >View Document</a
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12 col-12" class="tab-view">
              <div class="text-center p-relative">
                <div class="circle">
                  <img class="profile-pic" [src]="image_urls" />
                </div>
                <div class="p-image">
                  <label for="files"
                    ><i class="fa fa-camera upload-button"></i
                  ></label>
                  <input
                    class="file-upload"
                    (change)="onSelectImage($event)"
                    id="files"
                    type="file"
                    accept="image/*"
                  />
                </div>
                <p class="logo-span">Logo <span class="text-danger">*</span></p>
                <p>
                  <span class="noti-span"
                    >(Supported Format: png,jpg,jpeg) <br />(Max file size:
                    10mb) <br />
                    (Suggested Image Dimensions: 160 x 160)</span
                  >
                </p>
                <p
                  *ngIf="
                    logoCheck &&
                    selecetdImage &&
                    selecetdImage.size / (1024 * 1024) > maxSizeMB
                  "
                  class="text-danger"
                >
                  File size exceeds the limit ({{ maxSizeMB }}MB)
                </p>
                <p *ngIf="logoCheck && !selecetdImage" class="text-danger">
                  Logo is required
                </p>
              </div>
            </div>
          </div>
        </form>
        <div class="text-center">
          <button
            *ngIf="roleValue == 'Corporate' && proReg == 'Yes'"
            class="mr-2 new-btn-color2"
            mat-raised-button
            color="warn"
            (click)="cancelEvent()"
          >
            Cancel
          </button>
          <button
            mat-raised-button
            color="primary"
            class="new-btn-color"
            (click)="updateProfile()"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
<app-footer></app-footer>
